/*
 * Copyright (c) CIRROM 2026.
 */

import { CrmVendor, resolveCrmVendor } from "../../../utils/crmVendor";
import { useOptionalSystemsAndProjects } from "../../../contexts/SystemsAndProjectsContext";

/**
 * The CRM vendor behind an integrated system, for the surfaces that name it.
 *
 * Read from context rather than threaded down from every host: a component
 * that merely wants to say "HubSpot" should not become unmountable outside
 * the provider, so a host without one gets null and falls back to its neutral
 * wording. Matched on `system_type`, never on the system's name - tenants name
 * their systems after themselves, so the demo tenant's HubSpot is "Cirrom",
 * and reading the name would send the steward to a CRM that does not exist.
 *
 * Shared because three places now speak the vendor's name: the dossier's
 * links, the ledger's "approvals write to ..." line, and the full record's
 * rule about where fields are edited. One resolution keeps them in step.
 */
export const useCrmVendor = (integratedSystemId?: number): CrmVendor | null => {
  const systemsAndProjects = useOptionalSystemsAndProjects();
  return resolveCrmVendor(
    systemsAndProjects?.integratedSystems.find(
      (system) => system.id === integratedSystemId
    )?.system_type
  );
};
